// Remove redundant whitespace from the string e.g. instances where there is two or more spaces between words
export const stripWhitespace = text => text.replace(/\s+/g, ' ');
export const stripHyphens = text => text.replace(/-/g, ' ');
